import { ProposalType } from '@insurancemenu/imenu-components-lib/dist/types/ProposalCard';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';

/**
 * Represents an RFQ Proposal page type, where the view varies depending on the type.
 * This is distinct from the proposal card type. Page types may require additional page logic,
 * but they do not affect the proposal card view.
 */
export type ProposalPageType = ProposalType | 'RELEASE' | 'CREATE_PORTFOLIO';

const getProposalType = (queryType: string): ProposalPageType => {
  switch (queryType) {
    case 'create-portfolio':
      return 'CREATE_PORTFOLIO';
    case 'rate':
      return 'RATE';
    case 'collateral':
      return 'FILE_UPLOAD';
    case 'release':
      return 'RELEASE';
    default:
      return 'GENERAL';
  }
};

export function useRFQProposalPageType(): ProposalPageType {
  const query = useQueryParams();
  const queryType = query.get('type') || '';

  return getProposalType(queryType);
}
